import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

interface PageProps {
	title?: string;
	description?: string;
	background?: string;
}

const StyledPage = styled.div``;

const Page: React.FC<React.PropsWithChildren<PageProps>> = ({
	children,
	title,
	description,
	background,
}) => {
	return (
		<>
			<>
				{!!title && (
					<Helmet>
						<title>{title}</title>
					</Helmet>
				)}
				{!!description && (
					<Helmet>
						<meta name="description" content={description} />
					</Helmet>
				)}
				<Helmet>
					<style>{`${
						background ? `body {background: ${background};}` : ""
					}`}</style>{" "}
				</Helmet>
			</>
			<StyledPage>{children}</StyledPage>
		</>
	);
};

export default Page;
